export default __webpack_public_path__ + "static/media/chatbutton.8008f92e.svg";